import { cn, sanitizeHtml } from "@/lib/utils";

interface RichHtmlProps {
  /** ISHONCHSIZ HTML: o'qituvchi, ariza beruvchi yoki mehmon yozgan. */
  html?: string | null;
  /** Kichikroq variant — dialog va kartalar ichida. */
  compact?: boolean;
  className?: string;
}

/**
 * Boy matnni chizadigan YAGONA joy.
 *
 * `dangerouslySetInnerHTML` ni har bir ekranda qo'lda yozish o'rniga bitta
 * komponent: tozalash unutilishi mumkin bo'lgan joy qolmaydi. Kontentni
 * o'qituvchilar, o'qituvchilikka ariza beruvchilar va murojaat yuborgan
 * mehmonlar YOZADI — ya'ni hammasi ishonchsiz manba.
 */
export const RichHtml = ({ html, compact, className }: RichHtmlProps) => {
  const trimmed = html?.trim();
  if (!trimmed) return null;

  return (
    <div
      className={cn("prose max-w-none", compact && "prose-sm", className)}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(trimmed) }}
    />
  );
};
